import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show_arena } from '../models/horse_show_arena';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class HorseShowArenaService {

  constructor(private http: HttpClient) {
  }

  getListForHorseShow(horse_show_id: string): Promise<Horse_show_arena[]> {
  	return this.getListWithRest('horse_show_id/' + horse_show_id);
  }

  private getListWithRest(rest_url: string) : Promise<Horse_show_arena[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horse_show_arenas/' + rest_url).subscribe((response:any) => {
			if(response.type == 'horse_show_arena_list' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }


}
